import { render } from "./CreateNoteForm.vue?vue&type=template&id=3cae9688&ts=true"
import script from "./CreateNoteForm.vue?vue&type=script&lang=ts"
export * from "./CreateNoteForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__